import type { CssTokenEntry } from "./designTokensCatalog";

export type MotionTokenSample = "easing" | "duration";

interface MotionTokenEntry extends CssTokenEntry {
    name: `--ease-${string}` | `--duration-${string}`;
    sample: MotionTokenSample;
    usage: string;
    isNotInFigma: true;
}

interface MotionTokenGroup {
    label: string;
    tokens: readonly MotionTokenEntry[];
}

// Mirrors styles/tokens/_motion.scss. Figma has no motion variables.
export const motionGroups = [
    {
        label: "Easing",
        tokens: [
            {
                name: "--ease-out",
                sample: "easing",
                usage: "UI entering or leaving the screen, and pops",
                isNotInFigma: true,
            },
            {
                name: "--ease-in-out",
                sample: "easing",
                usage: "Movement between two on-screen positions",
                isNotInFigma: true,
            },
        ],
    },
    {
        label: "Duration",
        tokens: [
            {
                name: "--duration-fast",
                sample: "duration",
                usage: "Color, hover and focus-ring fades; exits",
                isNotInFigma: true,
            },
            {
                name: "--duration-medium",
                sample: "duration",
                usage: "Popups opening, glyph pops, crossfades",
                isNotInFigma: true,
            },
            {
                name: "--duration-slow",
                sample: "duration",
                usage: "Content growing in, like a Field error",
                isNotInFigma: true,
            },
        ],
    },
] satisfies readonly MotionTokenGroup[];
